var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTicketNf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4123",
    "data-name": "Grupo 4123",
    transform: "translate(-270 -467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24px",
    "data-name": "24px",
    transform: "translate(270 467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260",
    "data-name": "Caminho 260",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "receipt_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11449",
    "data-name": "Caminho 11449",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11450",
    "data-name": "Caminho 11450",
    d: "M18,17H6V15H18Zm0-4H6V11H18Zm0-4H6V7H18ZM3,22l1.5-1.5L6,22l1.5-1.5L9,22l1.5-1.5L12,22l1.5-1.5L15,22l1.5-1.5L18,22l1.5-1.5L21,22V2L19.5,3.5,18,2,16.5,3.5,15,2,13.5,3.5,12,2,10.5,3.5,9,2,7.5,3.5,6,2,4.5,3.5,3,2Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTicketNf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ticket-nf.447e9260.svg";
export { ForwardRef as ReactComponent };